var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platelet model shadow-1 b-r-1 m-b-5"},[_c('p',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.platelet.name)+" ")]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.platelet.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }